import JobBlocksCardCarousel from '@/features/job-blocks/components/job-blocks-card-carousel';
import JobBlocksHighPaying from '@/features/job-blocks/components/job-blocks-high-paying';
import JobBlocksLocations from '@/features/job-blocks/components/job-blocks-locations';
import { JobBlocksProps, JobBlocksVariant } from '@/features/job-blocks/types';

export default function JobBlocks(props: JobBlocksProps) {
  if (props.variant === JobBlocksVariant.CARD_CAROUSEL) {
    return <JobBlocksCardCarousel {...props} />;
  }

  if (props.variant === JobBlocksVariant.HIGH_PAYING_JOBS) {
    return <JobBlocksHighPaying {...props} />;
  }

  return <JobBlocksLocations {...props} />;
}
